import { overlay } from 'overlay-kit';

import type { Campaign } from '@/entities/campaign';
import type { CampaignExportRequest } from '../helpers/campaign-export';
import { CampaignExportDialog } from './campaign-export-dialog';

export function requestCampaignExportDialog({
  canExport,
  campaign,
  onExport,
}: {
  canExport: boolean;
  campaign: Campaign;
  onExport: (request: CampaignExportRequest) => Promise<void>;
}): Promise<void> {
  return overlay.openAsync<void>(({ isOpen, close, unmount }) => (
    <CampaignExportDialog
      canExport={canExport}
      campaign={campaign}
      isOpen={isOpen}
      onCancel={close}
      onExport={async (request) => {
        await onExport(request);
        close();
      }}
      onUnmount={unmount}
    />
  ));
}
